import { KeysTabsAnalysis } from "@app/types/samples.types";

export const DEFAULT_CALCULATION_VALUES = {
  totalActivity: 0,
  totalUncertainty: 0,
  totalLid: 0,
  efficiencieTotal: 0,
  efficiencieMedia: 0,
};

export const SOURCE_APP = {
  GENIE: "GENIE",
  EXE: "EXE",
} as const;

export const PU_AM_CM_ANALYSIS_TYPES = [
  KeysTabsAnalysis.Pu238,
  KeysTabsAnalysis.Pu239_240,
  KeysTabsAnalysis.AM241,
  KeysTabsAnalysis.Cm243_244,
] as const;

export const ISOTOPE_CODE_PATTERNS = {
  PLUS_SEPARATOR: "+",
} as const;
